import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { S as Sortable } from './sortable.esm.js';
import { a as extractElementsFromSlot } from './slot-utils.js';

const trayCss = ":host{position:relative;box-sizing:border-box}:host *,:host *:before,:host *:after{box-sizing:inherit}:host{display:flex;flex-direction:column;gap:var(--tt-spacing-xs)}:host ::slotted(tt-tray-item.sortable-ghost){opacity:0}:host([data-sorting]:not([data-sorting=false])){cursor:grabbing}";

const Tray = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.ttChange = createEvent(this, "tt-change", 7);
    this.isSorting = false;
    this.handle = undefined;
  }
  connectedCallback() {
    this.handleSortStart = this.handleSortStart.bind(this);
    this.handleSortEnd = this.handleSortEnd.bind(this);
    this.sortable = Sortable.create(this.element, {
      animation: 250,
      draggable: 'tt-tray-item',
      handle: this.handle,
      forceFallback: true,
      direction: 'vertical',
      onStart: this.handleSortStart,
      onEnd: this.handleSortEnd,
    });
  }
  componentDidRender() {
    if (this.trayItemsSlot) {
      // Since it should ever only be the tt-tray element that knows about sorting, and it has the drag handle selector
      // as a property, we set the css rule for changing the cursor to grab for each individual slotted item element.
      const dragHandles = this.element.querySelectorAll(this.handle);
      dragHandles.forEach((el) => {
        el.style.cursor = 'grab';
      });
    }
  }
  handleSortStart(_) {
    this.isSorting = true;
    if (this.trayItemsSlot) {
      const items = extractElementsFromSlot(this.trayItemsSlot, 'tt-tray-item');
      items.forEach((item) => item.lockGutter());
    }
  }
  handleSortEnd(_) {
    this.isSorting = false;
    if (this.trayItemsSlot) {
      const items = extractElementsFromSlot(this.trayItemsSlot, 'tt-tray-item');
      items.forEach((item) => item.unlockGutter());
    }
    if (this.sortable) {
      this.ttChange.emit({ value: this.sortable.toArray() });
    }
  }
  render() {
    return (h(Host, { "data-sorting": this.isSorting }, h("slot", { ref: (el) => (this.trayItemsSlot = el) })));
  }
  get element() { return this; }
  static get style() { return trayCss; }
}, [1, "tt-tray", {
    "handle": [1],
    "isSorting": [32]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-tray"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-tray":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, Tray);
      }
      break;
  } });
}

const TtTray = Tray;
const defineCustomElement = defineCustomElement$1;

export { TtTray, defineCustomElement };
